/*=====================================
    Topbar

    Author: Gray
    CreateTime: 2019 / 01 / 25
=====================================*/
window.InifECApp.directive('topbar', ['$rootScope', '$state', 'UserService', 'OrderService', 'ShoppingCartService', 'ProductService', '$timeout', '$InifECGA',
    function($rootScope, $state, UserService, OrderService, ShoppingCartService, ProductService, $timeout, $InifECGA) 
    {
        var _dir = {};

        /*--------------------------
            controller
        --------------------------*/
        var controller = ['$scope', function($scope) {

            // ------------------------------
            // [SCOPE] 是否active 在 all product state
            // ------------------------------
            var isCurrentAllProduct = function() {

                return $state.includes(window.STATES.ALL_PRODUCT) || $state.includes(window.STATES.PRODUCT_LIST);
            }

            // ------------------------------
            // [SCOPE] 是否active 在 faq state
            // ------------------------------
            var isCurrentFAQ = function() {

                return $state.includes(window.STATES.FAQ);
            }

            // ------------------------------
            // [SCOPE] 是否active 在 about state
            // ------------------------------
            var isCurrentAbout = function() {

                return $state.includes(window.STATES.ABOUT);
            }

            // ------------------------------
            // [SCOPE] 登入
            // ------------------------------
            var login = function() {

                $rootScope.$broadcast('OPEN_LOGIN_MODAL');
            }

            // ------------------------------
            // [SCOPE] 登出
            // ------------------------------
            var logout = function() {

                $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {

                    title: '登出',
                    description: '即將登出inif印衣服，確定嗎？',
                    callback: function(result) {
                        if(result) {
                            const mrscid = UserService.user.id;

                            UserService.logout().then(function(result) {
                                $scope.isLogin = false;
                                $scope.user = undefined;

                                OrderService.cleanOrderCount();
                                $rootScope.$broadcast('LOGOUT_SUCCESS');
                                $InifECGA.setMrscid("");
                                $InifECGA.eventTrack('member', 'logout', mrscid);
                            }, function(error) {
                                $scope.isLogin = false;
                            });
                        }
                    }
                });
            }

            // ------------------------------
            // 取得尚未付款訂單數量
            // ------------------------------
            var getOrderPayBadget = function() {

                OrderService.getOrderPayBadget().then(function(result) {
                });
            }

            // --------------------------------
            // 取得商品分類
            // --------------------------------
            var getProductClassListLite = function() {

                if($scope.isLoadingList) {
                    return;
                }

                $scope.isLoadingList = true;
                ProductService.getProductClassListLite().then(function(result) {

                    if(result && Array.isArray(result.mainPdtClass) && result.mainPdtClass.length > 0) {

                        var _result = shallowCopy(result);
                        var complexPdtMap = _result.complexPdtMap;
                        
                        $.each(_result.pdtClass_ProductMap, function(index, value) {
                            $scope.productList = $scope.productList.concat(formatProducts(value, complexPdtMap));
                        });
                    }

                    $scope.isLoadingList = false;
                }, function(error) {
                    $scope.isLoadingList = false;
                });
            }

            // --------------------------------
            // 將複合商品組合
            // --------------------------------
            var formatProducts = function(products, complexPdtMap) {

                var complexMap = {};
                var _products = [];

                for(var i = 0; i < products.length; i++) {
                    var product = products[i];
                    product.isComplex = false;

                    // 判斷是否為複合商品
                    if(product.complexidList && product.complexidList.length > 0) {

                        product.isComplex = true;
                        product.complexname = product.name;

                        var complexid = product.complexidList[0];

                        if(complexPdtMap[complexid] && complexMap[complexid] == undefined) {

                            complexMap[complexid] = i;

                            var complex = complexPdtMap[complexid];
                            product.complexname = complex ? complex.name : product.name;

                        } else if(complexPdtMap[complexid]){
                            continue;
                        }
                    }

                    _products.push(product);
                }

                return _products;
            }

            // --------------------------------
            // [SCOPE] Focus搜尋欄
            // --------------------------------
            var focusSearchInput = function() {

                $scope.isFocusSearchInput = true;

                if($scope.productList && $scope.productList.length > 0) {
                    return;
                } else {
                    getProductClassListLite();    
                }
            }

            // --------------------------------
            // [SCOPE] blur搜尋欄
            // --------------------------------
            var blurSearchInput = function() {

                $scope.isFocusSearchInput = false;
            }

            // ------------------------------
            // [SCOPE] 取得會員的大頭貼
            // ------------------------------
            var getMemberphotoUrl = function() {

                if($scope.isLogin) {
                    return $scope.user.memberphotoUrl;
                } else {
                    return './images/dummy/dummy_member_150.png';
                }
            }

            // --------------------------------
            // 取得使用者資訊
            // --------------------------------
            var getUserInfo = function(skipCache) {

                UserService.getUserInfo(skipCache).then(function(result) {
                    $scope.isLogin = true;
                    $scope.user = result;

                    getOrderPayBadget();

                    // GA 設定自訂維度
                    $InifECGA.setMrscid(result.mrscid);

                }, function(error) {
                    $scope.isLogin = false;
                });
            }
            
            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var init = function() {

                getUserInfo(false);

                $timeout(function(){
                    requestAnimationFrame(function() {
                        $rootScope.$broadcast('LOAD_ALL_MODALS');
                    });
                });
            }

            //==========================
            //  Events
            //==========================
            $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

                $scope.state = $state.current.name;
            });

            $scope.$on('LOGIN_SUCCESS', function(event, data){
                getUserInfo(true);
                // 登入成功後重新拉購物車資訊
                ShoppingCartService.getShoppingCart(true);
            });

            $scope.$on('LOGOUT_SUCCESS', function(event, data){
                $scope.isLogin = false;

                OrderService.cleanOrderCount();
                getUserInfo(true);
            });

            $scope.$on('UPDATE_MEMBER_PHOTO', function(event, data){

                $scope.user.memberphotoUrl = data;
            });

            $scope.$on('UPDATE_USER_INFO', function(event, data){

                getUserInfo(true);
            });        

            $scope.$watch('form.selectedPdt', function(newValue, oldValue) {  

                if($scope.form.selectedPdt && $scope.form.selectedPdt.originalObject && $scope.form.selectedPdt.originalObject.productid) {

                    if($scope.form.selectedPdt.originalObject.isComplex && $scope.form.selectedPdt.originalObject.complexidList
                        && $scope.form.selectedPdt.originalObject.complexidList.length > 0 && $scope.form.selectedPdt.originalObject.complexidList[0]) {

                        $state.go(window.STATES.COMPLEX_PDT, {
                            complexid: $scope.form.selectedPdt.originalObject.complexidList[0],
                            productid: $scope.form.selectedPdt.originalObject.productid
                        });
                    } else {
                        $state.go(window.STATES.PRODUCT, {
                            productid: $scope.form.selectedPdt.originalObject.productid
                        });
                    }               
                } else if($scope.form.selectedPdt && $scope.form.selectedPdt.title) {

                    if($scope.state == window.STATES.SEARCH_FAQ) {
                        $state.go(window.STATES.SEARCH_FAQ, {
                            keyword: $scope.form.selectedPdt.title
                        });
                    } else {
                        $state.go(window.STATES.SEARCH_PDT, {
                            keyword: $scope.form.selectedPdt.title
                        });
                    }
                }
            });  

            /*--------------------------
                Members
            --------------------------*/
            $scope.form = {
                keyword: '',
                selectedPdt: undefined
            };

            $scope.state;
            $scope.user;
            $scope.productList = [];
            $scope.isLogin = false;
            $scope.isLoadingList = false;
            $scope.isFocusSearchInput = false;
            $scope.orderCount = OrderService.orderCount;
            $scope.getAllCartShoppingCartItemSize = ShoppingCartService.getAllCartShoppingCartItemSize;

            /*--------------------------
                Methods
            --------------------------*/
            $scope.isCurrentAllProduct = isCurrentAllProduct; // 是否active 在 all product state
            $scope.isCurrentAbout = isCurrentAbout; // 是否active 在 faq state
            $scope.isCurrentFAQ = isCurrentFAQ; // 是否active 在 about state
            $scope.login = login; // 登入
            $scope.logout = logout; // 登出
            $scope.focusSearchInput = focusSearchInput; // Focus搜尋欄
            $scope.blurSearchInput = blurSearchInput; // blur搜尋欄
            $scope.getMemberphotoUrl = getMemberphotoUrl; // 取得會員的大頭貼
            
            /*--------------------------
                Init
            --------------------------*/
            init();
        }];

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = "partials/directives/topbar.html";
        _dir.controller = controller;

        return _dir;
    }
]);